import { Paper, Tab, Tabs, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FrontendSettingsTab } from '../../interfaces/Settings/SettingsTab';
import { availableFrontendSettingsTabs } from '../../variables/FrontendSettings';
import { sharedStyles } from '../../utils/Style';

const DummyScrollButton = () => <></>;

interface FrontendSettingsTabsProps {
  selectedTab: FrontendSettingsTab;
}

export const FrontendSettingsTabs = (props: FrontendSettingsTabsProps) => {
  const navigate = useNavigate();

  const handleChange = useCallback(
    (_: any, i: number) =>
      navigate(
        `/visual/frontend-settings/${availableFrontendSettingsTabs[i].path}`,
      ),
    [],
  );

  return (
    <Paper>
      <Tabs
        variant='scrollable'
        value={availableFrontendSettingsTabs.findIndex(
          (tab) => tab.kind === props.selectedTab,
        )}
        onChange={handleChange}
        ScrollButtonComponent={DummyScrollButton}
      >
        {availableFrontendSettingsTabs.map((tab) => (
          <Tab
            key={tab.kind}
            label={
              <Typography sx={sharedStyles.tabLabel}>{tab.name}</Typography>
            }
          />
        ))}
      </Tabs>
    </Paper>
  );
};
